import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { Mutations } from '@shared/api';

type DeleteEntitiesFunction = (ids: MBAPI.Scalar.UUID[]) => Promise<true>;

export function useDeleteEntitiesMutation(workflowTemplateId: string): DeleteEntitiesFunction {
  const [deleteEntities] = useMutation<
    MBAPI.DeleteWorkflowEntitiesMutation,
    MBAPI.DeleteWorkflowEntitiesMutationVariables
  >(Mutations.entity.deleteWorkflowEntities);

  return useCallback(
    async (ids: MBAPI.Scalar.UUID[]) => {
      const input = {
        workflowTemplateId,
        ids,
      };
      const { data } = await deleteEntities({
        variables: { input },
      });

      const success = data?.deleteWorkflowEntities;

      if (success) {
        return success;
      } else {
        throw new Error('Failed to delete entities');
      }
    },
    [workflowTemplateId, deleteEntities],
  );
}
